import styled from 'styled-components/macro';

// eslint-disable-next-line import/prefer-default-export
export const PageHeading = styled.h1`
  margin-bottom: 0;
  flex-grow: 1;
`;
